import {Component, EventEmitter, Input, OnInit, Output, Renderer2} from '@angular/core';
import {SubscriptionsService} from '../_services/subscriptions.service';

@Component({
  selector: 'app-jinni-modal',
  templateUrl: './jinni-modal.component.html',
  styleUrls: ['./jinni-modal.component.scss']
})
export class JinniModalComponent implements OnInit {
  @Input() visible: boolean;
  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  modalIsVisible: boolean;
  constructor(private subscriptionsService: SubscriptionsService, private renderer: Renderer2) {
      this.modalIsVisible = false;
      this.subscriptionsService.getCloseModal().subscribe( data => {
          if (data === true) {
              this.modalIsVisible = false;
              setTimeout(() => {
                  this.visible = false;
                  this.visibleChange.emit(this.visible);
                  this.subscriptionsService.emitModalState(false);
                  this.renderer.removeClass(document.body, 'modal-open');
                  setTimeout(() => {
                    this.subscriptionsService.closeModalNow(false);
                    this.modalIsVisible = true;
                  }, 10);
              }, 700);
          }
      });
  }

  ngOnInit() {
      setTimeout( () => {
          this.modalIsVisible = true;
      }, 250);
  }



}
